// extracted by mini-css-extract-plugin
export var buttonInner = "transition-weekly-module--button-inner--55865";
export var container = "transition-weekly-module--container--64426";
export var content = "transition-weekly-module--content--97ae3";
export var errorText = "transition-weekly-module--error-text--3fb76";
export var header = "transition-weekly-module--header--1a12b";
export var loader = "transition-weekly-module--loader--e3243";
export var loading = "transition-weekly-module--loading--86e28";
export var title = "transition-weekly-module--title--ee56f";